// ============================================================================
// FENWICK TREE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'fenwick-tree',
  name: 'Fenwick Tree',
  category: 'Data Structures',
  complexity: {
    time: 'O(log N) per operation',
    space: 'O(N)'
  },
  description: 'Also known as a Binary Indexed Tree, it provides efficient methods for calculating prefix sums and updating array elements. Uses a clever indexing scheme to achieve O(log N) time for both operations with O(N) space.'
};
